import { Link } from 'gatsby'
import React from 'react'

export interface LinkButtonProps extends React.ComponentPropsWithoutRef<'a'> {}

const isLinkExternal = (link: string | undefined) => {
  if (link) {
    const match = link.match(/tel:|mailto:|http:|https:|sms:/gi)

    return !!match?.length
  }

  return false
}

export const LinkButton = ({ children, href, className }: LinkButtonProps) => {
  let _className: string = 'button '
  const isExternal = isLinkExternal(href)

  _className += className ? ` ${className}` : ''

  if (isExternal) {
    return (
      <a className={_className} href={href!}>
        {children}
      </a>
    )
  }

  return (
    <Link className={_className} to={href!}>
      {children}
    </Link>
  )
}
